'use strict';

/* global $ */

import { Ajax } from 'utils/ajax';

function Regions(options) {

	let opt = $.extend(true, {}, options);

	function initBlock(el) {
		let $el = $(el);

		opt = $.extend({
			mapSelector: opt.selector+'__block',
		}, opt);

		let myMap, $map;

		$map = $(opt.mapSelector);
		if (!$map.length) return;
		console.log('[ Regions/init ]');

	    myMap = new ymaps.Map($map.get(0), {
	        center: [65, 100],
	        zoom: 2,
	        type: null,
	        controls: ['zoomControl']
	    },{
	        restrictMapArea: [[10, 10], [85,-160]]
	    });
	    myMap.controls.get('zoomControl').options.set({size: 'small'});
	    // Добавим заливку цветом.
	    var pane = new ymaps.pane.StaticPane(myMap, {
	        zIndex: 100, css: {
	            width: '100%', height: '100%', backgroundColor: '#ffffff'
	        }
	    });
	    myMap.panes.append('white', pane);
	    // Загрузим регионы.
		ymaps.borders.load('RU', {
		  	lang: 'ru',
		  	quality: 2
		}).then(function (geojson) {
			let clickObject;
			let selectedObject = $map.data('area');
			for (let i = 0; i < geojson.features.length; i++) {
				let geoObject = new ymaps.GeoObject(geojson.features[i]);
				geoObject.options.set('fillColor', '#d6ebff');
				geoObject.options.set('strokeColor', '#0d0d0d');
				let iso3166 = geoObject.properties.get('iso3166');
				if (selectedObject == iso3166) {
					geoObject.options.set('fillColor', '#418acd');
				}
				geoObject.events
					.add('click', function (e) {
						clickObject = e.get('target').properties.get('iso3166');
						e.get('target').options.set('fillColor', '#418acd');

						let params = {
							area_iso_code: clickObject
						}

						Ajax.get('set_area', params).then((data) => {
							delete self.loading;
							if (data.reload) {
								//document.location.href = document.location.protocol + '//' + document.location.hostname + '/?_current_area=' + data.area.area_id + '#regions';
								//document.location.reload(true);
								window.location.replace(document.location.protocol + '//' + document.location.hostname + '/?_current_area=' + data.area.area_id + '&_filter_area=1#SearchTabContent');
							}
						}).catch(function(error) {
							throw new Error(error);
						});

					})
					.add('mouseenter', function (e) {
						e.get('target').options.set('fillColor', '#418acd');
					})
					.add('mouseleave', function (e) {
						if (clickObject != e.get('target').properties.get('iso3166') && selectedObject != e.get('target').properties.get('iso3166')) {
							e.get('target').options.set('fillColor', '#d6ebff');
						}
					});
				myMap.geoObjects.add(geoObject);
			}
/*
		  	let regions = ymaps.geoQuery(geojson);

		  	regions.setOptions('fillColor', '#d6ebff');
		  	regions.setOptions('strokeColor', '#0d0d0d');
		  	regions.search('properties.iso3166 = "RU-IRK"').setOptions('fillColor', '#418acd');
		  	regions.addToMap(myMap);

		  	for (let region in regions) {
		  		console.error(region);
				region.events
					.add('mouseenter', function (e) {
						e.get('target').options.set('fillColor', '#418acd');
					})
					.add('mouseleave', function (e) {
						e.get('target').options.set('fillColor', '#d6ebff');
					});
			}
*/
		});
	}

	if ($(opt.selector).length == 0) return;
	if (typeof ymaps !== 'undefined') {
		ymaps.ready(function() {
			$(opt.selector).each(function() {
				initBlock(this);
			});
		});
	} else {
		let count = 0;
		let timerId = setInterval(function() {
			count++;
			console.log('[ Regions/test ] ' + count);
			if (typeof ymaps !== 'undefined') {
				ymaps.ready(function() {
					$(opt.selector).each(function() {
						initBlock(this);
					});
				});
				clearInterval(timerId);
			}
			if (count > 2) {
				clearInterval(timerId);
			}
		}, 500);
	}
}

export {
	Regions
};
